import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { omit } from 'ramda'
import { Tag } from 'examkrackers-components'
import qs from 'qs'
import styled from 'styled-components'
import * as R from 'ramda'

type BookFiltersTagProps = {
  book: {
    id: string
    tag: string
    tag_colour: string
  }
  disabled?: boolean
}

const BookFiltersTag = ({ book, disabled = false }: BookFiltersTagProps) => {
  const {
    replace,
    location: { pathname, search }
  } = useHistory()

  const isActive = useMemo(() => {
    const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })
    const currentBookId = R.pathOr('', ['filter', 'b.id'], parsedQuery)
    return currentBookId === book.id
  }, [search, book.id])

  const handleClick = () => {
    if (disabled) return

    const parsedQuery = qs.parse(search, { ignoreQueryPrefix: true })
    const bookIdFilter = isActive ? {} : { 'b.id': book.id }

    const newQuery = {
      ...parsedQuery,
      filter: {
        ...omit(
          ['bcc.id', 'bs.id', 'b.id', '__unassigned'],
          parsedQuery.filter
        ),
        ...bookIdFilter
      }
    }

    replace(`${pathname}${qs.stringify(newQuery, { addQueryPrefix: true })}`)
  }

  return (
    <TagWrapper $disabled={disabled} aria-disabled={disabled}>
      <Tag
        text={book.tag}
        color={book.tag_colour}
        isActive={isActive}
        // Keep active styling visible while loading — only block clicks
        onClick={disabled ? undefined : handleClick}
      />
    </TagWrapper>
  )
}

export default BookFiltersTag

const TagWrapper = styled.div<{ $disabled: boolean }>`
  & > div:first-of-type {
    white-space: nowrap;
  }

  ${({ $disabled }) =>
    $disabled &&
    `
    pointer-events: none;
    cursor: not-allowed;
  `}
`
